import { render, staticRenderFns } from "./Install.vue?vue&type=template&id=2b300ff5&scoped=true"
import script from "./Install.vue?vue&type=script&lang=js"
export * from "./Install.vue?vue&type=script&lang=js"
import style0 from "./Install.vue?vue&type=style&index=0&id=2b300ff5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b300ff5",
  null
  
)

export default component.exports